<template>
  <div class="lifesupport-launcher">
    <v-btn
      class="lifesupport-launcher-btn text-white"
      color="#A5D867"
      elevation="8"
      icon
      :href="ticketUrlSafe"
      target="_blank"
      rel="noopener noreferrer"
      :aria-label="ariaLabel"
      :title="ariaLabel"
    >
      <v-icon icon="chat" color="white" />
    </v-btn>
  </div>
</template>

<script>
  import { DEFAULT_LIFE_ON_LIFE_TICKET_URL } from '@/constants/lifeOnLifeSupport'

  export default {
    name: 'LifeOnLifeSupportLauncher',
    computed: {
      ariaLabel() {
        return typeof this.$t === 'function'
          ? this.$t('navbar.tooltips.supportLifeOnLife')
          : 'Open Life on Life support'
      },
      ticketUrlSafe() {
        const raw =
          this.$store.getters['AppData/getSupportChatConfig']?.lifeOnLifeSupport
            ?.ticketUrl
        const s = typeof raw === 'string' ? raw.trim() : ''
        return s || DEFAULT_LIFE_ON_LIFE_TICKET_URL
      },
    },
  }
</script>

<style scoped>
  .lifesupport-launcher {
    position: fixed;
    right: 18px;
    bottom: 38px;
    z-index: 2147483000;
  }

  /* Match Vuetify icon button sizing to other support launchers */
  .lifesupport-launcher-btn {
    border-radius: 50% !important;
  }

  @media print {
    .lifesupport-launcher {
      display: none !important;
    }
  }
</style>
